<template>
  <div class="band-filters d-flex align-items-center justify-content-center gap-2 flex-wrap">
    <div class="checkbox-wrapper-10 compact flex-grow-1" v-for="(filter, index) in filters" :key="index">
      <input class="tgl tgl-flip" :id="`band-${filter.id}`" type="checkbox" :checked="filter.active"
        @change="toggleFilter(filter.id)" v-b-tooltip.hover :title="filter.title">
      <label class="tgl-btn compact" data-tg-off="Off" :data-tg-on="filter.label" :for="`band-${filter.id}`" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    filters() {
      return [
        { id: 'all', label: 'All', title: this.$t('general.all', 'All'), active: !this.value.filterAll },
        { id: 'ovr', label: 'OVR', title: this.$t('general.overview', 'Overview'), active: !this.value.filterOVR },
        { id: 'gnr', label: 'GNR', title: this.$t('general.general', 'General'), active: !this.value.filterGNR },
        { id: 'cst', label: 'CST', title: this.$t('general.coastal', 'Coastal'), active: !this.value.filterCST },
        { id: 'apr', label: 'APR', title: this.$t('general.approach', 'Approach'), active: !this.value.filterAPR },
        { id: 'hrb', label: 'HRB', title: this.$t('general.harbour', 'Harbour'), active: !this.value.filterHRB },
        { id: 'brg', label: 'BRG', title: this.$t('general.berthing', 'Berthing'), active: !this.value.filterBRG }
      ];
    }
  },
  methods: {
    toggleFilter(id) {
      const newValue = { ...this.value };

      if (id === 'all') {
        const newState = !newValue.filterAll;
        // Изменяем все фильтры
        newValue.filterAll = newState;
        newValue.filterOVR = newState;
        newValue.filterGNR = newState;
        newValue.filterCST = newState;
        newValue.filterAPR = newState;
        newValue.filterHRB = newState;
        newValue.filterBRG = newState;
      } else {
        // Изменяем только конкретный фильтр
        switch (id) {
          case 'ovr': newValue.filterOVR = !newValue.filterOVR; break;
          case 'gnr': newValue.filterGNR = !newValue.filterGNR; break;
          case 'cst': newValue.filterCST = !newValue.filterCST; break;
          case 'apr': newValue.filterAPR = !newValue.filterAPR; break;
          case 'hrb': newValue.filterHRB = !newValue.filterHRB; break;
          case 'brg': newValue.filterBRG = !newValue.filterBRG; break;
        }

        // Обновляем состояние общего фильтра
        const allOn = !newValue.filterOVR && !newValue.filterGNR && !newValue.filterCST &&
          !newValue.filterAPR && !newValue.filterHRB && !newValue.filterBRG;
        const allOff = newValue.filterOVR && newValue.filterGNR && newValue.filterCST &&
          newValue.filterAPR && newValue.filterHRB && newValue.filterBRG;

        if (allOn) newValue.filterAll = false;
        else if (allOff) newValue.filterAll = true;
      }

      this.$emit('input', newValue);
      this.$emit('change', newValue);
    }
  }
}
</script>

<style scoped>
/* Стили для контейнера переключателей бендов */
.band-filters {
  padding: 6px 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

/* Стили для переключателей флип-анимации */
.checkbox-wrapper-10 {
  margin-right: 8px;
  margin-bottom: 4px;
}

.checkbox-wrapper-10 .tgl {
  display: none;
}

.checkbox-wrapper-10 .tgl,
.checkbox-wrapper-10 .tgl:after,
.checkbox-wrapper-10 .tgl:before,
.checkbox-wrapper-10 .tgl *,
.checkbox-wrapper-10 .tgl *:after,
.checkbox-wrapper-10 .tgl *:before,
.checkbox-wrapper-10 .tgl+.tgl-btn {
  box-sizing: border-box;
}

.checkbox-wrapper-10 .tgl::-moz-selection,
.checkbox-wrapper-10 .tgl:after::-moz-selection,
.checkbox-wrapper-10 .tgl:before::-moz-selection,
.checkbox-wrapper-10 .tgl:before::-moz-selection,
.checkbox-wrapper-10 .tgl *::-moz-selection,
.checkbox-wrapper-10 .tgl *:after::-moz-selection,
.checkbox-wrapper-10 .tgl *:before::-moz-selection,
.checkbox-wrapper-10 .tgl+.tgl-btn::-moz-selection,
.checkbox-wrapper-10 .tgl::selection,
.checkbox-wrapper-10 .tgl:after::selection,
.checkbox-wrapper-10 .tgl:before::selection,
.checkbox-wrapper-10 .tgl *::selection,
.checkbox-wrapper-10 .tgl *:after::selection,
.checkbox-wrapper-10 .tgl *:before::selection,
.checkbox-wrapper-10 .tgl+.tgl-btn::selection {
  background: none;
}

.checkbox-wrapper-10 .tgl+.tgl-btn {
  outline: 0;
  display: block;
  width: 3.5em;
  height: 1.8em;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox-wrapper-10 .tgl+.tgl-btn:after,
.checkbox-wrapper-10 .tgl+.tgl-btn:before {
  position: relative;
  display: block;
  content: "";
  width: 50%;
  height: 100%;
}

.checkbox-wrapper-10 .tgl+.tgl-btn:after {
  left: 0;
}

.checkbox-wrapper-10 .tgl+.tgl-btn:before {
  display: none;
}

.checkbox-wrapper-10 .tgl:checked+.tgl-btn:after {
  left: 50%;
}

.checkbox-wrapper-10 .tgl-flip+.tgl-btn {
  padding: 2px;
  transition: all 0.2s ease;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  perspective: 100px;
  font-size: 0.75rem;
}

.checkbox-wrapper-10 .tgl-flip+.tgl-btn:after,
.checkbox-wrapper-10 .tgl-flip+.tgl-btn:before {
  display: inline-block;
  transition: all 0.4s ease;
  width: 100%;
  text-align: center;
  position: absolute;
  line-height: 1.6em;
  font-weight: 600;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.checkbox-wrapper-10 .tgl-flip+.tgl-btn:after {
  content: attr(data-tg-on);
  background: #007bff;
  transform: rotateY(-180deg);
}

.checkbox-wrapper-10 .tgl-flip+.tgl-btn:before {
  background: #6c757d;
  content: attr(data-tg-off);
}

.checkbox-wrapper-10 .tgl-flip+.tgl-btn:active:before {
  transform: rotateY(-20deg);
}

.checkbox-wrapper-10 .tgl-flip:checked+.tgl-btn:before {
  transform: rotateY(180deg);
}

.checkbox-wrapper-10 .tgl-flip:checked+.tgl-btn:after {
  transform: rotateY(0);
  left: 0;
  background: #0056b3;
}

.checkbox-wrapper-10 .tgl-flip:checked+.tgl-btn:active:after {
  transform: rotateY(20deg);
}

/* Специальные стили для кнопки "All" */
.checkbox-wrapper-10:first-child .tgl-flip+.tgl-btn:after {
  background: #28a745;
}

.checkbox-wrapper-10:first-child .tgl-flip:checked+.tgl-btn:after {
  background: #218838;
}

/* Компактные стили для узких экранов */
.checkbox-wrapper-10.compact {
  margin-right: 3px;
  /* уменьшено с 4px */
  margin-bottom: 3px;
  /* уменьшено с 4px */
  flex: 1;
  display: flex;
  justify-content: center;
}

.checkbox-wrapper-10.compact .tgl+.tgl-btn.compact {
  width: 2.5em;
  /* уменьшено с 4.2em */
  height: 1.7em;
  /* уменьшено с 2.1em */
  font-size: 0.9rem;
  /* уменьшено с 1.05rem */
  padding: 2px 0px;
  /* убраны горизонтальные отступы полностью */
}

.checkbox-wrapper-10.compact .tgl-flip+.tgl-btn.compact:after,
.checkbox-wrapper-10.compact .tgl-flip+.tgl-btn.compact:before {
  line-height: 1.6em;
  /* уменьшено с 1.8em */
  font-size: 0.8rem;
  /* уменьшено с 0.95rem */
  padding: 1px 0px;
  /* убраны горизонтальные отступы */
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .band-filters {
    padding: 6px 8px;
  }

  .checkbox-wrapper-10 {
    margin-right: 4px;
    margin-bottom: 2px;
  }

  .checkbox-wrapper-10 .tgl+.tgl-btn {
    width: 3em;
    height: 1.5em;
  }

  .checkbox-wrapper-10 .tgl-flip+.tgl-btn {
    font-size: 0.65rem;
  }

  .checkbox-wrapper-10 .tgl-flip+.tgl-btn:after,
  .checkbox-wrapper-10 .tgl-flip+.tgl-btn:before {
    line-height: 1.3em;
  }
}

/* Уменьшенные отступы для контейнера фильтров на узких экранах */
@media (max-width: 1200px) {
  .band-filters {
    padding: 4px 6px;
    /* уменьшено с 6px 8px */
    gap: 0.15rem !important;
    /* уменьшено с 0.2rem */
    display: flex;
    justify-content: space-between;
  }

  .checkbox-wrapper-10.compact {
    margin-right: 1px;
    /* уменьшено с 2px */
    margin-bottom: 1px;
    /* оставлено как было */
    flex: 1;
  }
}
</style>